import { createFeatureSelector } from '@ngrx/store';
import { FileState } from '../reducers';
import { MODULE_KEY } from '../../constants';

export const selectFileModuleState = createFeatureSelector<FileState>(MODULE_KEY);
